module.exports = __webpack_public_path__ + "static/media/kg.1c92e07a.png";